import { ExerciseFileDto, ExerciseFiles, ExerciseFileTypes } from '../exercises/exercises.types';

const emptyFiles = (): ExerciseFiles => ({
  [ExerciseFileTypes.question]: [],
  [ExerciseFileTypes.attachment]: [],
  [ExerciseFileTypes.answer]: [],
  [ExerciseFileTypes.hint]: [],
});

const parseExerciseFilesForUI = (rawFiles: ExerciseFileDto[] | null | undefined): ExerciseFiles => {
  const files = Array.isArray(rawFiles) ? [...rawFiles] : [];
  return files
    .sort((a, b) => a.file_index - b.file_index)
    .reduce<ExerciseFiles>((prev, { file_type, cropped_png_file }) => {
      if (!file_type || !(file_type in prev)) {
        return prev;
      }
      return { ...prev, [file_type]: [...prev[file_type], cropped_png_file] };
    }, emptyFiles());
};

export default parseExerciseFilesForUI;
